import React from 'react';
import colors from '../ColorConfig/colorconfig';

const { white } = colors;

const WorkProcessHeader = ({ isVisible }) => {
  return (
    <div style={{ textAlign: "center", marginBottom: "45px", overflow: "hidden" }}>
      <div 
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(100px) scale(0.95)',
          transition: 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
          filter: isVisible ? 'blur(0)' : 'blur(4px)'
        }}
      >
        <h1 
          className="display-5 fw-bold work-process-title"
          style={{
            color: white,
            marginBottom: '16px',
            transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
            opacity: isVisible ? 1 : 0,
            transition: 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0.1s'
          }}
        >
          Our Work Process
        </h1>
        <h2 
          className='work-subtitle'
          style={{ 
            color: white, 
            marginBottom: 0,
            opacity: 0.8,
            transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0.2s',
            fontSize: '1.0rem'
          }}
        >
          From Idea to Execution - A Smooth Journey with IDLBAY
        </h2>
      </div>
    </div>
  );
};

export default WorkProcessHeader;